import { IPageConfig } from "../interfaces/page_config";
import { IMessage } from "../interfaces/message";
import { MessageOptions } from "./message_options";
import { IFormInput } from "../interfaces/form_input";
import { PropsComponent, PropsLayoutCarousel } from "../props";
import { IFeedbackCooldownEntry, IFeedbackTextEntry } from "./chat/feedback";

export type StateOption = {
	apiServer: string;
	companyId: number;
	companyToken: string;
	extBotId: number;
	messages: IMessage[];
	isBotHasAvatar: boolean;
	avatarSrc: string;
	convId: string;
	userId: string;
	isConfigurationLoaded: boolean;
	sendMsgUrl: string;
	maintainState: boolean;
	prefixClassName: string;
	showInfoPanel: boolean;
	errorMessage: string;
	showTypingIndicator: boolean;
	showProcessingMessage: boolean;
	processingDisplayIcon: string;
	processingDisplayText: string;
	pageId: string;
	socketId: string;
	lastMessageId: number;
	shouldShowBanner: boolean;
	isAppInAdaMode: boolean;
	retryWarningCount: number;
	retryInterval: number;
	isIFrameLoaded: boolean;
	isShowHeaderInIframe: boolean;
	isHideTitleBar: boolean;
	satisfiURL: string;
	headerImage: string;
	backgroundImage: string;
	headerImageDestinationURL: string;
	headerImageDestTrackingURL: string;
	isBrowseUrlOnSametab: boolean;
	typingMessageSecondsInterval: number;
	typingType: number;
	isUserHasAvatar: boolean;
	AWSServerURL: string;
	AWSThemeFilePath: string;
	AWSImageLogoPath: string;
	AWSPopupConfigPath: string;
	popupId: string;
	pageReferralUrl: string;
	disableInput: boolean;
	defaulthideInputContainerSetting: boolean;
	lastFocusableElement: Object;
	bannerText: string;
	userLat: string;
	userLng: string;
	locationBlocked: boolean;
	userIdSourceTypeId: number;
	parentSiteUrl: string;
	parentSiteReferralUrl: string;
	requestResponseReceived: boolean;
	focusedWindow: boolean;
	isSignalRConnected: boolean;
	isAnchorTagClickedSametabNewtab: boolean;
	clientVersion: string;
	minimumClientVersion: string;
	isTilesOpenedInIframe: boolean;
	cfHeader: string;
	showAdminLoginModal: boolean;
	showConsentModal: boolean;
	showTranscriptModal: boolean;
	isAdminMode: boolean;
	enableAdminMode: boolean;
	webApiAddress: string;
	dashboardAddress: string;
	attemptNoofInvalidCode: number;
	attemptNoofResendCode: number;
	mfaExpiration: number;
	mfaEnableDateTime: string;
	authToken: string;
	authTokenExpiration: number;
	isMFAEnabled: boolean;
	refreshTask: any;
	isTermsConsentEnabled: boolean;
	isFirstUserMessage: boolean;
	isTermsOfServiceAccepted: boolean;
	termsConsentPayload: string;
	termsConsentExpiration: string;
	consentStatusOptions: MessageOptions | null;
	formInputs: IFormInput[];
	showWelcomeBanner: boolean;
	isNewMessageProcessing: boolean;
	isMaintainStateMessages: boolean;
	enableMessageNavigation: boolean;
	pageConfig: IPageConfig;
	isMessagesRestored: boolean;
	carouselModalDetail: PropsComponent | null;
	carouselModalList: PropsLayoutCarousel | null;
	clientSiteLanguage: string | null;
	baseInlineActionUrl: string;
	taglineUrl: string;
	shouldSkipDefaultScroll: boolean;
	maintainStateQueue?: IMessage[];
	isWelcomeMessageProcessed?: boolean;
	feedbackCooldowns: Record<string, IFeedbackCooldownEntry>;
	feedbackTexts: Record<string, IFeedbackTextEntry>;
	feedbackDownButtonLabels: string[];
	feedbackClickCooldownSeconds: number;
	isStreamingMessages: boolean;
	senderDisplayName: string;
	skipWelcomeMessageOnURLInput: boolean;
	aiAgentAvatarUrl: string;
	liveAgentAvatarUrl: string;
};
